export enum RegionalPricingTypeEnum {
  "City" = 1,
  "Metropolitan" = 2,
}

export enum RegionalPricingStatusEnum {
  "Option1" = 1,
  "Option2" = 2,
}
